export default __webpack_public_path__ + "static/media/UsedCars.56e0f361.jpg";